import useSWR from "swr";

import { ApiRoute, ApiVenueMap } from "../types";

export default function useVenueRoutes(venueUUID?: string) {
  const { data, error, isValidating } = useSWR<ApiRoute[]>(
    venueUUID ? `/venues/${venueUUID}/routes` : null
  );
  return {
    routes: data,
    error,
    isValidating,
  };
}

export const useRoute = ({
  venueUUID,
  routeUUID,
}: {
  venueUUID?: string;
  routeUUID?: string;
}) => {
  const { routes, isValidating, error } = useVenueRoutes(venueUUID);
  const route = routes?.find((route_) => route_.uuid === routeUUID);
  return { route, isValidating, error };
};

export const useVenueMaps = (venueUUID?: string) => {
  const { data, error, isValidating } = useSWR<{ maps: ApiVenueMap[] }>(
    venueUUID ? `/venues/${venueUUID}` : null
  );
  return { maps: data?.maps, error, isValidating };
};
